import App from "./App";
import router from "./router";
import i18n from "./lang/index";
import "../static/js/flexible.js";

// 解决移动端点击延时300ms的问题
FastClick.attach(document.body);
// 解决IOS输入框聚焦不灵敏问题
FastClick.prototype.focus = function(targetElement) {
  targetElement.focus();
};

// 国际化
Vue.use({
  i18n: (key, value) => i18n.t(key, value)
});

// router.afterEach((to, from, next) => {
//   window.scrollTo(0, 0);
// });

Vue.config.productionTip = false;

import api from "@/api/export";
import * as Default from "../static/js/default.js";
import * as Echarts from "../static/js/echarts.js";
import bridge from "../static/js/bridge.js";
import * as config from "../static/js/config.js";


Vue.prototype.$api = api;
Vue.prototype.$default = Default;
Vue.prototype.$echarts = Echarts;
Vue.prototype.$bridge = bridge;
Vue.prototype.$config = config;

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  i18n,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js